
















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Table extends Vue {
  @Prop() readonly head!: [];

  @Prop() readonly houseEdge!: number;

  @Prop() readonly currency!: string;

  @Prop() readonly isRatio!: boolean;
}
